export function HeaderDecorationImg() {
  return (
    <svg width="438" height="100%" viewBox="0 0 438 302" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.8">
        <path
          d="M41.6769 24.4074L211.712 194.442L366.633 194.442L461.412 289.221M556.19 384L461.412 289.221M161.331 370.775L78.8327 288.277L78.8327 194.442L12.708 128.318M461.412 289.221L205.414 289.221L149.996 233.802"
          stroke="#8071B0"
        />
        <circle cx="38.3508" cy="19.6707" r="7.6701" transform="rotate(-90 38.3508 19.6707)" fill="#9D91C4" />
        <circle cx="149.995" cy="233.487" r="3.77856" transform="rotate(-90 149.995 233.487)" fill="#8071B0" />
        <circle cx="7.6701" cy="123.216" r="7.6701" transform="rotate(-90 7.6701 123.216)" fill="#9D91C4" />
        <path
          d="M293.581 133.987L294.081 133.987L294.081 133.78L293.934 133.634L293.581 133.987ZM226.826 69.8994C228.299 69.8994 229.493 68.7055 229.493 67.2327C229.493 65.7599 228.299 64.566 226.826 64.566C225.353 64.566 224.159 65.7599 224.159 67.2327C224.159 68.7055 225.353 69.8994 226.826 69.8994ZM294.081 193.185L294.081 133.987L293.081 133.987L293.081 193.185L294.081 193.185ZM293.934 133.634L227.18 66.8791L226.473 67.5863L293.227 134.341L293.934 133.634Z"
          fill="#8071B0"
        />
      </g>
      <g opacity="0.8">
        <path
          d="M325.677 -153.593L495.712 16.4424L650.633 16.4424L745.412 111.221M840.19 206L745.412 111.221M445.331 192.775L362.833 110.277L362.833 16.4424L296.708 -49.6823M745.412 111.221L489.414 111.221L433.996 55.8024"
          stroke="#8071B0"
        />
        <circle cx="433.995" cy="55.4871" r="3.77856" transform="rotate(-90 433.995 55.4871)" fill="#8071B0" />
      </g>
    </svg>
  );
}
